import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import useDebounce from 'modules/common/components/UseDebounce';
import * as actions from '../action';
import * as c from '../constant';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';
import EWalletServicesContent from './EWalletServicesContent';

const form = {
  keyword: '',
};

function EWalletServicesContainer({
  match,
  history,
  getServiceList,
  serviceList,
  serviceListPager,
  isLoading,
  removeService,
  showService,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add E Wallet Service',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update E Wallet Service',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove?',
      () => {
        removeService(data.id, () => {
          getServiceList({}, (response) => {
            const id = _.get(response, 'data.0.id');
            history.push(`/e-wallet-services/${id}`);
            showService(id);
          });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getServiceList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getServiceList({ q: formData.keyword, sort_by: 'desc' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:serviceId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="E-Wallet Service List"
            getData={getServiceList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:serviceId?`}
            listName="E Wallet Services"
            label="E Wallet Services"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <p> {_.get(item, 'attributes.name')} </p>
              </div>
            )}
            isLoading={isLoading}
            selected={params.serviceId}
            data={serviceList}
            dataPager={serviceListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:serviceId?`}
                    render={() => (
                      <EWalletServicesContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:serviceId?`}
                  render={() =>
                    !params.serviceId && serviceList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(serviceList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

EWalletServicesContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getServiceList: PropTypes.instanceOf(Function).isRequired,
  serviceList: PropTypes.instanceOf(Array).isRequired,
  serviceListPager: PropTypes.instanceOf(Object).isRequired,
  removeService: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showService: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  serviceList: _.get(api, `${c.GET_SERVICE}.list`) || [],
  serviceListPager: _.get(api, `${c.GET_SERVICE}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_SERVICE) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(EWalletServicesContainer);
